/**
 * Pestañas de la sección s-productos-des: cambia la colección visible,
 * su enlace "Ver todo" y el degradado de la fila de pestañas en móvil.
 */
class SProductosDes extends HTMLElement {
  /** @type {HTMLElement | null} */
  #tablist = null;
  /** @type {HTMLButtonElement[]} */
  #tabs = [];
  /** @type {ResizeObserver | undefined} */
  #resizeObserver;

  connectedCallback() {
    this.#tablist = this.querySelector('[role="tablist"]');
    this.#tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (!this.#tablist || this.#tabs.length === 0) return;

    this.#tablist.addEventListener('click', this.#onClick);
    this.#tablist.addEventListener('keydown', this.#onKeydown);
    this.#tablist.addEventListener('scroll', this.#updateOverflow, { passive: true });

    this.#resizeObserver = new ResizeObserver(this.#updateOverflow);
    this.#resizeObserver.observe(this.#tablist);
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    const tab = /** @type {HTMLElement} */ (event.target).closest('[role="tab"]');
    if (tab instanceof HTMLButtonElement) this.#select(tab);
  };

  /** @param {KeyboardEvent} event */
  #onKeydown = (event) => {
    const index = this.#tabs.indexOf(/** @type {HTMLButtonElement} */ (event.target));
    if (index === -1) return;

    const last = this.#tabs.length - 1;
    const next = {
      ArrowRight: index === last ? 0 : index + 1,
      ArrowLeft: index === 0 ? last : index - 1,
      Home: 0,
      End: last,
    }[event.key];
    if (next === undefined) return;

    event.preventDefault();
    this.#select(this.#tabs[next], true);
  };

  /**
   * @param {HTMLButtonElement} tab
   * @param {boolean} [focus]
   */
  #select(tab, focus = false) {
    const tabNumber = tab.dataset.tab;

    for (const item of this.#tabs) {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    }

    for (const element of this.querySelectorAll('[role="tabpanel"], .productos-des__view-all')) {
      if (element instanceof HTMLElement) element.hidden = element.dataset.tab !== tabNumber;
    }

    if (focus) tab.focus();
    tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  #updateOverflow = () => {
    const tablist = this.#tablist;
    if (!tablist) return;

    const maxScroll = tablist.scrollWidth - tablist.clientWidth;
    const atStart = tablist.scrollLeft <= 1;
    const atEnd = tablist.scrollLeft >= maxScroll - 1;

    if (maxScroll <= 1) delete tablist.dataset.overflow;
    else if (atStart) tablist.dataset.overflow = 'end';
    else if (atEnd) tablist.dataset.overflow = 'start';
    else tablist.dataset.overflow = 'both';
  };
}

if (!customElements.get('s-productos-des')) {
  customElements.define('s-productos-des', SProductosDes);
}
